import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Link, withRouter } from 'react-router-dom';
import classnames from 'classnames';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleRight from '@fortawesome/fontawesome-free-solid/faAngleRight';
import isTouchDevice from 'is-touch-device';
import onClickOutside from 'react-onclickoutside';
import MegaMenuChildren from './MegaMenuChildren';
import { getItemById } from '../lib/util';
import './MegaMenu.css';

class MegaMenu extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.props.toggleSearch({
      closeOnly: true,
    });
    event.target.parentNode.classList.toggle('is-active');
    event.stopPropagation();
  }

  handleClickOutside = () => {
    const menu = document.getElementById('megamenu');
    if (menu.classList.contains('is-active')) {
      menu.classList.remove('is-active');
    }
  };

  render() {
    const {
      to, title, structure, categories, location, toggleSearch,
    } = this.props;
    return (
      <div
        className={`navbar-item has-dropdown ${isTouchDevice() ? '' : 'is-hoverable '}is-mega ${
          location.pathname.indexOf('/catalog') !== -1 ? 'has-active-bottom-border' : ''
        }`}
        id="megamenu"
      >
        <Link className="navbar-link" to={to} onClick={this.handleClick}>
          {title}
        </Link>
        <div id="catalogDropdown" className="navbar-dropdown">
          <div className="columns">
            <div className="column">
              {structure.map((elem) => {
                const category = getItemById({
                  array: categories,
                  id: elem.id,
                  key: 'category_ID',
                });
                const linkToPath = `/catalog/${elem.id}`;
                
                // const isActive = window.location.href.indexOf(linkToPath) !== -1;
                const isActiveRegex = new RegExp(`${linkToPath.replace(/\//g, '\\/')}($|\\/)`);
                const isActive = location.pathname.match(isActiveRegex);
                
                return (
                  <Link
                    key={`menu${elem.id}`}
                    className={classnames({
                      'navbar-item': true,
                      'is-active': isActive,
                    })}
                    to={linkToPath}
                    onClick={this.handleClick}
                  >
                    <div className="navbar-content">
                      <span className="category category--major">
                        <FontAwesomeIcon
                          className={classnames({
                            icon: true,
                            'is-active': isActive,
                          })}
                          icon={faAngleRight}
                        />
                        <span>{category.title}</span>
                      </span>
                    </div>
                  </Link>
                );
              })}
            </div>
            <div className="columns catalogDropdown-columns">
              <Route
                path="/catalog/:id"
                render={properties => (
                  <MegaMenuChildren
                    structure={structure}
                    categories={categories}
                    toggleSearch={toggleSearch}
                    {...properties}
                  />
                )}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MegaMenu.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  structure: PropTypes.arrayOf(PropTypes.object).isRequired,
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  toggleSearch: PropTypes.func.isRequired,
};

MegaMenu.defaultProps = {
  location: {
    pathname: '/',
  },
};

export default withRouter(onClickOutside(MegaMenu));



// WEBPACK FOOTER //
// ./src/components/MegaMenu.js